import * as React from 'react';
import styled from 'styled-components';
import { Ref } from 'react';
import ExcelExportButton from 'components/common/file/ExcelExportButton';
import DataTableHeader from 'components/common/table/datatable/DataTableHeader';
import DataTableLayout from 'components/common/table/datatable/DataTableLayout';
import { ExcelMemberExport, Member, MemberExcel } from 'types/member';
import NewDataTableBody from 'components/common/table/datatable/NewDataTableBody';
import { closetMemberListColumns } from './MemberListColumns';
import { getUtcDateNoDash } from 'modules/utils/time';

interface Props {
  memberList: Member[];
  totalPages: number;
  mailListExportData: MemberExcel[];
  mailListExportLoading: boolean;
  marketingAgreeExportData: MemberExcel[];
  marketingAgreeExportLoading: boolean;
  onClickMailListExport: () => void;
  onClickMarketingAgreeExport: () => void;
  refs: { [key: string]: Ref<HTMLButtonElement> };
  memberListLoading: boolean;
  onChangePage: (pageIndex: number) => void;
  currentPageIndex: number;
  totalItems: number;
}

const MemberListTable = ({
  memberList,
  onClickMailListExport,
  onClickMarketingAgreeExport,
  mailListExportData,
  mailListExportLoading,
  marketingAgreeExportData,
  marketingAgreeExportLoading,
  refs, // multiple ref 넘기기 위해 props 로 전달
  totalPages,
  memberListLoading,
  onChangePage,
  currentPageIndex,
  totalItems,
}: Props) => {
  const { mailListExportRef, marketingAgreeExportRef } = refs;
  const memberListColumnData = closetMemberListColumns(totalItems, currentPageIndex);
  const today = getUtcDateNoDash(new Date()); // YYYYMMDD 형태
  return (
    <DataTableLayout
      showPagination
      totalPages={totalPages}
      onChangePage={onChangePage}
      currentPageIndex={currentPageIndex}
      upperButton={
        <UpperButtons>
          <ExcelExportButton
            width={140}
            buttonText={'Export Email List'}
            fileName={`closet_member_mailing_list_${today}`}
            sheetName={today}
            ref={mailListExportRef}
            onClickExport={onClickMailListExport}
            exportData={mailListExportData}
            exportLoading={mailListExportLoading}
          />
          <ExcelExportButton
            width={240}
            buttonText={'Export Marketing Agreement List'}
            fileName={`closet_member_marketing_list_${today}`}
            sheetName={today}
            ref={marketingAgreeExportRef}
            onClickExport={onClickMarketingAgreeExport}
            exportData={marketingAgreeExportData}
            exportLoading={marketingAgreeExportLoading}
          />
        </UpperButtons>
      }
    >
      <DataTableHeader header={memberListColumnData} />
      <NewDataTableBody
        loading={memberListLoading}
        dataList={memberList}
        columns={memberListColumnData}
      />
    </DataTableLayout>
  );
};
export default MemberListTable;

const UpperButtons = styled.div`
  display: flex;
  gap: 8px;
`;
